import React from "react"

export default function Footer() {
    return (
        <footer>
            <p>Designed &amp; developed with 💖 since 2021 by <a href="https://www.vincentle.me/">Vincent Le</a> © {new Date().getFullYear()}</p>
        </footer>
    )
}
